export function convertToNumber(value) {
  const num = Number(value);
  if (Number.isNaN(num)) return null;
  return Number.isInteger(num) ? parseInt(num, 10) : parseFloat(num);
}
